import { render, staticRenderFns } from "./ExpirationMessage.vue?vue&type=template&id=55a5d954&scoped=true&"
import script from "./ExpirationMessage.vue?vue&type=script&lang=js&"
export * from "./ExpirationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationMessage.vue?vue&type=style&index=0&id=55a5d954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a5d954",
  null
  
)

export default component.exports